import { SET_USER } from '@/store/mutation-types'

export default {
  state: {
    name:'',
    mobile:'',
    access_token:'',
  },
  getters: {
    name: state => {
      return state.name
    },
    mobile: state => {
      return state.mobile
    },
    access_token: state => {
      return state.access_token
    }
  },
  mutations: {
    [SET_USER] (state, user) {
      state.name =  user.name
      state.access_token =  user.access_token
      state.mobile =  user.mobile
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js